export const MENU_DATA = [
  {
    order: 1,
    name: "产品",
    subMenus: [
      {
        submenu: [
          {
            link: "/product-community/",
            name: "社区版",
            submenu: null,
          },
          {
            link: "https://pingcap.com.cn",
            name: "企业版",
            submenu: null,
          },
          {
            link:
              "https://www.pingcap.com/tidb-dedicated/?utm_source=website-zh&utm_medium=referral&utm_campaign=tidb-cloud",
            name: "TiDB Cloud",
            submenu: null,
          },
          {
            link:
              "https://www.pingcap.com/tidb-serverless/?utm_source=website-zh&utm_medium=referral&utm_campaign=tidb-serverless",
            name: "TiDB Serverless",
            submenu: null,
          },
        ],
        link: "/product",
        name: "tidb",
        type: "logo",
      },
      {
        submenu: [
          {
            link: "/product#ecological-tools",
            name: "安装部署",
            submenu: null,
          },
          {
            link: "/product#ecological-tools",
            name: "数据流转",
            submenu: null,
          },
          {
            link: "/product#ecological-tools",
            name: "集群容灾",
            submenu: null,
          },
          {
            link: "/product#ecological-tools",
            name: "运维可视化",
            submenu: null,
          },
        ],
        link: "/product#ecological-tools",
        name: "TiDB 工具",
        type: "standard",
      },
    ],
    id: "Menu-groups_1",
  },
  {
    order: 2,
    name: "解决方案",
    subMenus: [
      {
        submenu: [
          {
            link: "",
            name: "行业解决方案",
            submenu: [
              {
                name: "商业银行核心系统解决方案",
                link:
                  "https://cn.pingcap.com/solution/commercial-bank-core-system-solution/",
              },
              {
                name: "ECIF 解决方案",
                link: "https://cn.pingcap.com/solution/tidb-ecif-solution/",
              },
              {
                name: "实时数据服务解决方案",
                link:
                  "https://cn.pingcap.com/solution/tidb-realtime-data-service-solution/",
              },
              {
                name: "多租户与业务整合解决方案",
                link:
                  "https://cn.pingcap.com/solution/multi-tenant-database-consolidation-solution/",
              },
              {
                name: "交易与核算分离解决方案",
                link:
                  "https://cn.pingcap.com/solution/accounting-engine-based-on-tidb/",
              },
              {
                name: "查看全部行业解决方案",
                link:
                  "https://cn.pingcap.com/solution/?category=industry-solutions",
                isSystemLink: true,
              },
            ],
          },
          {
            link: "",
            name: "基础架构解决方案",
            submenu: [
              {
                name: "Oracle 到 TiDB 迁移方案",
                link:
                  "https://cn.pingcap.com/solution/migration-from-oracle-to-tidb/",
              },
              {
                name: "多集群管理解决方案",
                link:
                  "https://cn.pingcap.com/solution/tidb-multi-cluster-mgmt-solution/",
              },
              {
                name: "跨地域容灾解决方案",
                link:
                  "https://cn.pingcap.com/solution/tidb-remote-disaster-recovery/",
              },
              {
                name: "双中心多活解决方案",
                link:
                  "https://cn.pingcap.com/solution/dual-center-multi-active-solution/",
              },
              {
                name: "查看全部基础架构解决方案",
                link: "/solution/?category=infrastructure-solutions",
                isSystemLink: true,
              },
            ],
          },
        ],
        link: "/solution",
        name: "解决方案",
        type: "two-column",
      },
      {
        submenu: [
          {
            name: "金融",
            link: "/resources/finance/",
          },
          {
            name: "新经济",
            link: "/resources/new-economy/",
          },
          {
            name: "企业出海",
            link: "/events/tidb-enabling-china-enterprise-go-global/",
          },
          {
            name: "查看全部行业洞见",
            link: "/insight/",
            isSystemLink: true,
          },
        ],
        link: "/insight",
        name: "行业专区",
        type: "standard",
      },
      {
        submenu: [
          {
            name: "TiDB 最佳实践",
            link: "/practice/tidb-best-practices/",
          },
          {
            name: "TiDB 数据库开发规范",
            link:
              "/practice/best-practices-for-developing-applications-with-tidb/",
          },
          {
            name: "高并发写入场景最佳实践",
            link: "/practice/high-concurrency-best-practices/",
          },
          {
            name: "PD 调度策略最佳实践",
            link: "/practice/pd-scheduling-best-practices/",
          },
          {
            name: "异构数据库最佳实践",
            link: "/practice/heterogeneous-database-replication-best-practice/",
          },
          {
            name: "查看全部最佳实践",
            link: "/practice/",
            isSystemLink: true,
          },
        ],
        link: "/practice",
        name: "最佳实践",
        type: "standard",
      },
    ],
    id: "Menu-groups_2",
  },
  {
    order: 3,
    name: "文档",
    subMenus: [
      {
        submenu: [
          {
            link:
              "https://docs.pingcap.com/zh/tidb/stable/quick-start-with-tidb",
            name: "快速上手",
            submenu: null,
          },
          {
            link:
              "https://docs.pingcap.com/zh/tidb/stable/production-deployment-using-tiup",
            name: "本地部署",
            submenu: null,
          },
          {
            link: "https://docs.pingcap.com/zh/tidb-in-kubernetes/stable",
            name: "云上部署",
            submenu: null,
          },
          {
            link: "https://docs.pingcap.com/zh/tidb/stable/migration-overview",
            name: "数据迁移",
            submenu: null,
          },
          {
            link:
              "https://docs.pingcap.com/zh/tidb/stable/use-br-command-line-tool",
            name: "备份恢复",
            submenu: null,
          },
          {
            link: "https://docs.pingcap.com/zh/tidb/stable/dev-guide-overview",
            name: "开发指南",
            submenu: null,
          },
          {
            link: "https://docs.pingcap.com/zh/tidb/stable/tidb-faq",
            name: "常见问题解答",
            submenu: null,
          },
        ],
        link: "https://docs.pingcap.com/zh",
        name: "TiDB 文档",
        type: "standard",
      },
    ],
    id: "Menu-groups_8",
  },
  {
    order: 4,
    name: "客户案例",
    subMenus: [
      {
        submenu: [
          {
            link: "",
            name: "金融",
            submenu: [
              {
                name: "国有大型银行",
                link: "/case/htap-in-large-scale-data-service-of-a-state-owned-bank/",
              },
              {
                name: "中国光大银行",
                link: "/case/user-case-china-everbright-bank/",
              },
              {
                name: "北京银行",
                link: "/case/user-case-beijing-bank/",
              },
              {
                name: "微众银行",
                link: "/case/user-case-webank/",
              },
              {
                name: "平安人寿",
                link: "/case/user-case-pingan/",
              },
              {
                name: "查看全部客户案例",
                link: "/case/",
                isSystemLink: true,
              },
            ],
          },
          {
            link: "",
            name: "零售与电商",
            submenu: [
              {
                name: "百胜中国",
                link: "/case/user-case-yum-china/",
              },
              {
                name: "小米",
                link: "/case/user-case-xiaomi-2021/",
              },
              {
                name: "小红书",
                link: "/case/user-case-xiaohongshu/",
              },
              {
                name: "多点 DMall",
                link: "/case/user-case-dmall/",
              },
            ],
          },
          {
            link: "",
            name: "视频与游戏",
            submenu: [
              {
                name: "爱奇艺",
                link: "/case/user-case-iq/",
              },
              {
                name: "Bilibili",
                link: "/case/user-case-bilibili/",
              },
              {
                name: "网易互娱",
                link: "/case/user-case-wangyihuyu/",
              },
              {
                name: "昆仑万维",
                link: "/case/user-case-kunlun/",
              },
              {
                name: "CAPCOM",
                link: "/case/user-case-capcom/",
              },
            ],
          },
          {
            link: "",
            name: "物流",
            submenu: [
              {
                name: "中通快递",
                link: "/case/user-case-zto-express/",
              },
              {
                name: "安能物流",
                link: "/case/user-case-ane/",
              },
              {
                name: "快成物流",
                link: "/case/user-case-kcl/",
              },
              {
                name: "Ninja Van",
                link: "/case/user-case-ninjavan/",
              },
            ],
          },
          {
            link: "",
            name: "生活服务",
            submenu: [
              {
                name: "美团",
                link: "/case/user-case-meituandianping/",
              },
              {
                name: "知乎",
                link: "/case/user-case-zhihu/",
              },
              {
                name: "携程",
                link: "/case/user-case-ctrip/",
              },
              {
                name: "58 集团",
                link: "/case/user-case-58/",
              },
              {
                name: "汽车之家",
                link: "/case/user-case-qichezhijia/",
              },
            ],
          },
          {
            link: "",
            name: "公用事业",
            submenu: [
              {
                name: "中国电信",
                link: "/case/user-case-bestpay/",
              },
              {
                name: "国网河北电力",
                link: "/case/user-case-state-grid-hebei/",
              },
              {
                name: "吉林祥云",
                link: "/case/user-case-jilinxiangyun/",
              },
              {
                name: "烟台税务",
                link: "/case/user-case-yantai-tax-bureau/",
              },
            ],
          },
        ],
        link: "/case",
        name: "客户案例",
        type: "two-column",
      },
    ],
    id: "Menu-groups_3",
  },
  {
    order: 5,
    name: "合作伙伴",
    subMenus: [
      {
        submenu: [
          {
            link: null,
            name: "成为合作伙伴",
            submenu: [
              {
                name: "解决方案伙伴",
                link: "https://cn.pingcap.com/solution-partner/",
              },
              {
                name: "授权经销伙伴",
                link: "https://cn.pingcap.com/distribution-partner/",
              },
              {
                name: "认证服务伙伴",
                link: "https://cn.pingcap.com/service-partner/",
              },
              {
                name: "产品生态伙伴",
                link: "https://cn.pingcap.com/ecological-partner/",
              },
              {
                name: "教育合作伙伴",
                link: "https://cn.pingcap.com/education-partner/",
              },
              {
                name: "查找合作伙伴",
                link: "/search-partner/",
                isSystemLink: true,
              },
            ],
          },
          {
            link: null,
            name: "联合解决方案",
            submenu: [
              {
                name: "商业银行核心系统解决方案",
                link:
                  "https://cn.pingcap.com/solution/commercial-bank-core-system-solution/",
              },
              {
                name: "ECIF 解决方案",
                link: "https://cn.pingcap.com/solution/tidb-ecif-solution/",
              },
              {
                name: "实时数据服务解决方案",
                link:
                  "https://cn.pingcap.com/solution/tidb-realtime-data-service-solution/",
              },
              {
                name: "多租户与业务整合解决方案",
                link:
                  "https://cn.pingcap.com/solution/multi-tenant-database-consolidation-solution/",
              },
              {
                name: "交易与核算分离解决方案",
                link:
                  "https://cn.pingcap.com/solution/accounting-engine-based-on-tidb/",
              },
              {
                name: "查看全部行业解决方案",
                link:
                  "https://cn.pingcap.com/solution/?category=industry-solutions",
                isSystemLink: true,
              },
            ],
          },
        ],
        link: "/partner",
        name: "合作伙伴",
        type: "two-column",
      },
    ],
    id: "Menu-groups_4",
  },
  {
    order: 6,
    name: "服务与支持",
    subMenus: [
      {
        submenu: [
          {
            link: "",
            name: "产品订阅",
            submenu: [
              {
                link: "",
                name:
                  "PingCAP 为企业客户提供产品订阅，通过该服务您可以获得完整的产品支持，持续的产品能力更新，周全而专业的产品支持专家经验赋能以及对您关键系统运行的可靠保障。",
              },
            ],
          },
          {
            link: "",
            name: "专家咨询服务",
            submenu: [
              {
                link: "",
                name:
                  "PingCAP 专家咨询服务为已经购买产品订阅的企业用户提供咨询规划、方案设计、变更保障、诊断与优化、经验传递等一系列专业服务。",
              },
            ],
          },
          {
            link: "",
            name: "专业培训服务",
            submenu: [
              {
                link: "",
                name:
                  "提供面向重点行业客户的 TiDB 定制化课程内容开发和交付服务，帮助培养具备全面架构和开发能力的 TiDB 数据库人才梯队，助力客户数字化转型和新业务增长。",
              },
            ],
          },
        ],
        link: "/support",
        name: "商业产品及服务",
        type: "contact-us",
      },
      {
        submenu: [
          {
            link: "/product/#select-product",
            name: "社区版 TiDB 下载",
            submenu: null,
          },
          {
            link:
              "https://docs.pingcap.com/zh/tidb/stable/quick-start-with-tidb",
            name: "快速上手指南",
            submenu: null,
          },
          {
            link: "https://docs.pingcap.com/zh",
            name: "TiDB 文档",
            submenu: null,
          },
          {
            link: "https://asktug.com/",
            name: "社区问答 - AskTUG",
            submenu: null,
          },
        ],
        link: "/support/#community-resources",
        name: "TiDB 社区支持",
        type: "standard",
      },
    ],
    id: "Menu-groups_5",
  },
  {
    order: 7,
    name: "学习与社区",
    subMenus: [
      {
        submenu: [
          {
            link: null,
            name: "教育",
            submenu: [
              {
                link: "/courses-catalog",
                name: "课程体系",
              },
              {
                link: "https://learn.pingcap.com/learner/certification-center",
                name: "认证体系",
              },
              {
                link: "/education-partner",
                name: "教育合作伙伴",
              },
            ],
          },
          {
            link: null,
            name: "校企合作",
            submenu: [
              {
                link: "/education-campus",
                name: "校园人才生态",
              },
              {
                link: "/education-science",
                name: "科研合作",
              },
              {
                link: "https://tidb.net/talent-plan",
                name: "Talent Plan",
              },
            ],
          },
        ],
        link: "/education/",
        name: "PingCAP Education",
        type: "two-column",
      },
      {
        submenu: [
          {
            link: "https://asktug.com/",
            name: "社区问答-AskTUG",
            submenu: null,
          },
          {
            link: "https://tidb.net/blog/",
            name: "社区专栏",
            submenu: null,
          },
          {
            link: "https://tidb.net/events/",
            name: "社区活动",
            submenu: null,
          },
          {
            link: "https://tidb.net/tug",
            name: "用户组",
            submenu: null,
          },
          {
            link:
              "https://ossinsight.io/?utm_source=website-zh&utm_medium=referral&utm_campaign=navi",
            name: "OSS Insight",
            submenu: null,
          },
        ],
        link: "https://tidb.net/",
        name: "TiDB 社区",
        type: "standard",
      },
      {
        submenu: [
          {
            name: "TiDB 源码阅读",
            link: "/blog/tag/tidb-source-code-reading/",
          },
          {
            name: "TiKV 源码解析",
            link: "/blog/tag/tikv-source-code-analysis/",
          },
          {
            name: "TiFlash 源码阅读",
            link: "/blog/tag/tiflash-source-code-reading/",
          },
          {
            name: "DM 源码阅读",
            link: "/blog/tag/dm-source-code-reading/",
          },
          {
            name: "Chaos Mesh",
            link: "/blog/tag/chaos-mesh/",
          },
          {
            name: "查看全部博客",
            link: "https://cn.pingcap.com/blog/",
            isSystemLink: true,
          },
        ],
        link: "/blog/",
        name: "博客",
        type: "standard",
      },
    ],
    id: "Menu-groups_6",
  },
]
